module.exports = __webpack_public_path__ + "assets/70651ba9ce59dddd060515e2feb51788.png";